import React, { useEffect } from "react";

function IssueItem({ issue, index }) {
  const delay = index * 3000;

  useEffect(() => {
    setTimeout(() => {
      const issueItem = document.querySelector(
        `.issue-item:nth-child(${index + 1})`
      );
      if (issueItem) {
        const height = issueItem.scrollHeight;
        issueItem.style.maxHeight = `${height}px`;
        issueItem.classList.remove("collapsed");
      }
    }, delay);
  }, [index, delay]);

  return (
    <div className="issue-item collapsed">
      <h5 className="text-primary">
        <strong>{issue.component}</strong>
      </h5>
      <p>
        <strong>Replacement Cost:</strong> {issue.cost}
      </p>
      <h6 className="text-uppercase">SubComponents:</h6>
      <ul>
        {issue.subComponents.map((subComponent) => (
          <li key={subComponent}>{subComponent}</li>
        ))}
      </ul>
      <div className="alert alert-warning" role="alert">
        <h6 className="text-uppercase">
          <strong>Sources:</strong>
        </h6>
        <ul className="mb-0">
          {issue.sources.map((source) => (
            <li key={source}>{source}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default IssueItem;
